module.exports = __webpack_public_path__ + "static/media/01Jungle.2f99d0a8.m4a";